// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"0bc2730a","787":"1d33e91f"}[chunkId] + ".chunk.js";
};